/* eslint-disable no-case-declarations */
import { types } from "../type";

const initialState = {
  queries: [],
  queryError: "",
  queryStatus: "",
  queryDetails: {},
  queryComment: {},
  queryResponse: "",
  queryDataTypes: "",
  queryLocation: "1",
  queryLoading: false,
  commentLoading: false,
  queryDate: "2022-07-30"
};

const queryReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case types.QueryTypes.QUERY_SET_CREATE_LOADING:
      return {
        ...state,
        queryLoading: payload
      };
    case types.QueryTypes.COMMENT_SET_CREATE_LOADING:
      return {
        ...state,
        commentLoading: payload
      };
    case types.QueryTypes.QUERY_ERRORS:
      return {
        ...state,
        queryLoading: false,
        queryError: payload.data.message,
        queryStatus: payload.status
      };
    case types.QueryTypes.ADD_QUERY:
      return {
        ...state,
        queryLoading: false,
        commentLoading: false,
        queryResponse: payload.message
      };
    case types.QueryTypes.QUERY_CLEAR_RESULT:
      return {
        ...state,
        queryResponse: ""
      };
    case types.QueryTypes.QUERY_CLEAR_ERRORS:
      return {
        ...state,
        queryError: ""
      };
    case types.QueryTypes.GET_ALL_QUERIES:
      const usersArray = payload.allQueries.map((queryData) => {
        const newArrayDynamic = [];
        const newArray = Object.assign({}, queryData);
        newArray.locationName = queryData?.locationId?.locationName;
        newArray.dataArray = newArrayDynamic;
        return newArray;
      });
      return {
        ...state,
        queryLoading: false,
        queries: usersArray
      };

    case types.QueryTypes.ALL_QUERY_INPUTS:
      return {
        ...state,
        queryDataTypes: payload.queryDataTypes,
        queryDate: payload.queryDate,
        queryLocation: payload.queryLocation
      };
    case types.QueryTypes.GET_QUERY_DETAILS:
      return {
        ...state,
        queryLoading: false,
        queryDetails: payload.queryDetails
      };
    case types.QueryTypes.ADD_QUERY_COMMENT:
      return {
        ...state,
        commentLoading: false,
        queryResponse: payload.message,
        queryDetails: payload.queryDetails
      };
    default:
      return state;
  }
};

export default queryReducer;
